import { FormLayoutAppearance } from 'src/app/layout/form-layout/form-layout.types'
import { ReservationF } from '../../types/reservation-detail.types'
import FormLayout from 'src/app/layout/form-layout/form-layout'
import { FormLayoutDefaultToolbar } from 'src/app/layout/form-layout/form-layout-toolbar'
import { useTranslation } from 'react-i18next'
import { FormItem } from 'hic-components'
import BillsDataFormHook, { BillsDataFormSchema } from './bills-data-form.hook'
import { Grid, TextField } from '@vapor/material'
import { Controller } from 'react-hook-form'

export default function BillsDataForm({
  reservation,
  appearance,
  title,
  loading,
  onSubmit,
  onCancel,
}: {
  reservation: ReservationF
  appearance: FormLayoutAppearance
  title: string
  loading: boolean
  onSubmit: (data: BillsDataFormSchema) => Promise<void>
  onCancel: () => void
}) {
  const { t } = useTranslation()
  const { onFormSubmit, control, errors } = BillsDataFormHook({ reservation, onSubmit })

  return (
    <FormLayout
      appearance={appearance}
      title={title}
      toolbar={
        <FormLayoutDefaultToolbar
          saveButton={{
            loading: loading,
            disabled: loading,
            clickHandler: onFormSubmit,
          }}
          cancelButton={{
            loading: loading,
            disabled: loading,
            clickHandler: onCancel,
          }}
        />
      }
    >
      <form onSubmit={onFormSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Controller<BillsDataFormSchema, 'paCIG'> //
              name={'paCIG'}
              control={control}
              render={({ field }) => (
                <FormItem fullWidth fieldLabel={t('pms.booking.reservation.pa_cig')} errorMessage={errors.paCIG?.message}>
                  <TextField disabled={loading} value={field.value ?? ''} onChange={field.onChange} error={Boolean(errors.paCIG)} />
                </FormItem>
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller<BillsDataFormSchema, 'paOrder'> //
              name={'paOrder'}
              control={control}
              render={({ field }) => (
                <FormItem fullWidth fieldLabel={t('pms.booking.reservation.pa_cup')} errorMessage={errors.paOrder?.message}>
                  <TextField disabled={loading} value={field.value ?? ''} onChange={field.onChange} error={Boolean(errors.paOrder)} />
                </FormItem>
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller<BillsDataFormSchema, 'voucher'> //
              name={'voucher'}
              control={control}
              render={({ field }) => (
                <FormItem fullWidth fieldLabel={t('pms.booking.reservation.form_voucher')} errorMessage={errors.voucher?.message}>
                  <TextField disabled={loading} value={field.value ?? ''} onChange={field.onChange} error={Boolean(errors.paOrder)} />
                </FormItem>
              )}
            />
          </Grid>
        </Grid>
      </form>
    </FormLayout>
  )
}
